import React from 'react';
import { Form as FinalForm } from 'react-final-form';

import { composeValidators, required } from '../../../../util/validators';
import { Button, FieldTextInput, Form } from '../../../../components';

import css from './SectionHero.module.css';

const RequestRuleBookForm = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const { form, handleSubmit, inAddUpdateProgress, intl, invalid, disabled } = fieldRenderProps;

      const submitDisabled = invalid || disabled || inAddUpdateProgress;

      return (
        <Form onSubmit={values => handleSubmit(values, form)}>
          <div className={css.folderWrapper}>
            <div className={css.folderStructure}>
              <div className={css.folderPlaceholder}>
                <FieldTextInput
                  className={css.inputBox}
                  label={intl.formatMessage({ id: 'RequestRulebookForm.rulebookLabel' })}
                  id={'rulebookName'}
                  name={'rulebookName'}
                  type="text"
                  placeholder={intl.formatMessage({
                    id: 'RequestRulebookForm.rulebookPlaceholder',
                  })}
                  validate={composeValidators(
                    required(intl.formatMessage({ id: 'RequestRulebookForm.rulebookRequired' }))
                  )}
                />
                <FieldTextInput
                  className={css.inputBox}
                  label={intl.formatMessage({ id: 'RequestRulebookForm.rulebookLinkLabel' })}
                  id={'rulebookLink'}
                  name={'rulebookLink'}
                  type="text"
                  placeholder={intl.formatMessage({
                    id: 'RequestRulebookForm.rulebookLinkPlaceholder',
                  })}
                />
                <FieldTextInput
                  className={css.inputBox}
                  label={intl.formatMessage({ id: 'RequestRulebookForm.notesLabel' })}
                  id={'admin'}
                  name={'admin'}
                  type="textarea"
                  placeholder={intl.formatMessage({ id: 'RequestRulebookForm.notesPlaceholder' })}
                  validate={composeValidators(
                    required(intl.formatMessage({ id: 'RequestRulebookForm.notesbookRequired' }))
                  )}
                />
              </div>
            </div>
            {/* <div className={css.spacer}></div> */}
            <div className={css.buttons}>
              <Button
                className={css.createGroup}
                type="submit"
                disabled={submitDisabled}
                inProgress={inAddUpdateProgress}
              >
                {intl.formatMessage({ id: 'RequestRulebookForm.submit' })}
              </Button>
            </div>
          </div>
        </Form>
      );
    }}
  />
);

export default RequestRuleBookForm;
